<template>
  <div class="main">
    <img src="@/assets/logo.png" alt="">
    <img src="@/assets/logo_txt.png" alt="">
    <span>二饼</span>
    <div class="btn_group">
      <div @click="handleGroup('doctor')">
        <span>我是医生</span>
        <img src="@/assets/icon_1.png" alt="">
      </div>
      <div @click="handleGroup('patient')">
        <span>我是患者</span>
        <img src="@/assets/icon_2.png" alt="">
      </div>
      <div @click="handleGroup('case')">
        <span>病例库</span>
        <img src="@/assets/icon_3.png" alt="">
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ElMessage } from 'element-plus';
import NavBar from '@/components/NavBar.vue';
import Footer from '@/components/Footers.vue'

const router = useRouter();
const store = useStore();

const data = reactive({
  userinfo: {}
});

// 处理按钮点击事件并进行路径跳转
const handleGroup = (type) => {
  console.log(type);

  // 检查用户是否已登录
  if (!store.getters.isLogin) {
    ElMessage.warning('请先登录');
    return;
  }

  switch (type) {
    case 'doctor':
      router.push('/doctor');
      break;
    case 'patient':
      router.push('/patient');
      break;
    case 'case':
      router.push('/case');
      break;
    default:
      break;
  }
}

onMounted(() => {
  console.log('mounted')
})
</script>

<style lang="scss" scoped>
.main {
  width: 100vw;
  height: calc(100vh - 90px);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  // justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 30px;

  >img:nth-child(1) {
    width: 148.5px;
    height: 106.2px;
    margin-bottom: 48px;
  }

  >img:nth-child(2) {
    width: 386px;
    object-fit: contain;
    margin-bottom: 44px;
  }

  >span {
    font-weight: bold;
    font-size: 32px;
    color: #0A0A0A;
    margin-bottom: 95px;
  }

  .btn_group {
    width: 100vw;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    gap: 37px;

    div {
      width: 338px;
      height: 140px;
      background: linear-gradient(-4deg, #E7EFFF, #FFFFFF);
      border-radius: 20px;
      border: 1px solid #C5CCE8;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 39px 40px 34px;
      cursor: pointer;

      span {
        font-weight: bold;
        font-size: 26px;
        // color: #6299FE;
        line-height: 77px;
        background: linear-gradient(166deg, #306BFD 0%, #9469FE 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        user-select: none;
      }

      img {
        width: 27px;
        height: 27px;
      }
    }
  }
}
</style>
